module.exports = __webpack_public_path__ + "static/img/project6.b0c61c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project6.png
// module id = uod9
// module chunks = 1